<template>
  <article class="content">  
    <h1>
      Liste de {{ $route.params.user }}
      <router-link to="/add" class="ico" title="Ajouter un cadeau" v-if="owner">
        <span class="fa fa-gift red"></span>
      </router-link>
      <router-link to="/order" class="ico" title="Changer l'ordre" v-if="owner">
        <span class="fa fa-sort red"></span>
      </router-link>
      <router-link v-bind:to="'/add/' + $route.params.user" class="ico" title="Ajouter un cadeau" v-if="impersonate">
        <span class="fa fa-gift red"></span>
      </router-link>
      <router-link v-bind:to="'/order/' + $route.params.user" class="ico" title="Changer l'ordre" v-if="impersonate">
        <span class="fa fa-sort red"></span>
      </router-link>
    </h1>
      <input type="checkbox" v-if="parent" name="impersonate" v-model="impersonate" @change="change" >
      <label for="impersonate" v-if="parent">gérer la liste</label>
      <input type="checkbox" v-if="parent" name="show" v-model="show">
      <label for="show" v-if="parent">montrer la liste</label>
    <div class="list">
      <Wish 
            v-for="w in wishes" 
            v-bind:key="w.id" 
            v-bind:wish="w"
            v-bind:owner="owner"
            v-bind:show="show"
            v-bind:impersonate="impersonate"
            v-on:describe="describeWish"
            v-on:deleted="deleted"></Wish>
    </div>
    <div v-if="showDescription" class="modal">
      <DescribedWish v-bind:wish="describedWish" v-on:close="close"></DescribedWish>
    </div>

  </article>
</template>

<script>

import Wish from './Wish'
import DescribedWish from './DescribedWish'

export default {
  props: ["hasList", "parent"],
  methods: {
    change() {
      console.log(this.impersonate)
      this.$cookies.set('impersonate', this.impersonate)
      /*
      let cookie_impersonate = this.$cookies.get('impersonate')
      console.log("imp = " + cookie_impersonate == 'true')
      if(this.parent && cookie_impersonate == 'true'){
        return true
      }
      return false
      */
    },
    deleted(wish) {
      this.wishes = this.sortWishes(this.wishes.filter(function(w){ return w.id != wish.id;}));
    },
    describeWish(wish) {
      this.describedWish = wish;
      this.showDescription = true;
    },
    close(){
      this.showDescription = false;
      this.describedWish = undefined;
    },
    sortWishes (wishes) {
      var sorted = wishes.sort((a, b) => (a.priority > b.priority) ? 1 : -1)
      sorted.forEach(function(part, index) {
        var wish = this[index]
        if (wish.reservation === undefined){ wish.reservation = null }
        if (wish.favorite === undefined){ wish.favorite = false }
        this[index] = wish;
      }, sorted);
      return sorted
    },
    loadWishes () {
      if(this.$route.params.user == undefined) {
        console.log("undefined user !!")
        this.$route.params.user=this.$oauth.getCurrentUser()
        this.$router.push({ path: "/list/" + this.$oauth.getCurrentUser() })
      }

      this.$api.wishlist(this.$route.params.user,this, function(component, data, wishOwner){
        data = component.sortWishes(data);
        const parsed = JSON.stringify(data);
        localStorage.setItem(wishOwner, parsed);
        component.wishes = data;
      }, function(component, wishOwner) {
        if(localStorage.getItem(this.$route.params.user)){
          try {
            component.wishes = JSON.parse(localStorage.getItem(wishOwner));
          } catch(e) {
            localStorage.removeItem(wishOwner);
          }
        }
      })
    }
  },
  computed: {
    owner: function() {      
      var owner = this.$oauth.getCurrentUser() == this.$route.params.user;
      return this.hasList && owner;
    }
  },
  updated() {
    let cookie_impersonate = this.$cookies.get('impersonate')
    if(this.parent && cookie_impersonate == 'true'){
      this.impersonate = true
    }else{
      this.impersonate = false
    }
  },
  mounted () {
    this.loadWishes()
  },
  data () {
    return {
      wishes: [],
      showDescription: false,
      describedWish: undefined,
      impersonate: false,
      show: false
    }
  },
  components: {Wish, DescribedWish}

}
</script>

<style>
.ico:hover > .red {
  color: lightseagreen;
}

.ico {
  text-decoration: none;
}

h1 {
	font-family: Trebuchet MS, Verdana, Arial, Sans-serif;
	font-size: 1.8em;
	margin: 10px;
  text-align: center;
}
.modal {
  border: thin solid indianred;
  background-color: white;
  position: fixed;
  width: 50%;
  height: 75%;
  top: 0;
  left: 0;
  z-index: 100;
  margin-left: 25%;
  margin-top: 5%;
}

@media only screen and (max-width: 600px) {
  .modal {
    border: thin solid indianred;
    background-color: white;
    position: fixed;
    width: 95%;
    height: 95%;
    top: 0;
    left: 0;
    z-index: 200;
    margin-left: 2%;
    margin-top: 2%;
  }
}

@media only screen and (min-width: 601px) {
  article {
    flex: 74%
  }
  h1 {
    text-align: left;
  }

}
</style>